interface RecentAlertPopoverSkeletonProps {
    length?: number;
}

const RecentAlertPopoverSkeleton: React.FC<RecentAlertPopoverSkeletonProps> = ({ length = 5 }) => {
    const skeletonItems = Array.from({ length });

    return (
        <div className="p-4">
            {skeletonItems.map((_, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <p key={`skeleton-${index}`}>
                    <span className="placeholder col-12"></span>
                </p>
            ))}
        </div>
    );
};

export default RecentAlertPopoverSkeleton;
